import { GET_PRODUCT_CHANGELOG } from './getProductChangelog';

export const aftermarketProductChangelogApi = {
  getProductChangelog: GET_PRODUCT_CHANGELOG,
};

export * from './types';
